import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { CRUMB_LABEL_KEY, NAME } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		dealers: [],
	},
	filter: {
		dealers: null as string | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
